"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SCHEMA = 'iglu:com.angi.events/mixpanel_session_replay_start/jsonschema/1-0-0';
const mixpanelSessionReplayStartEvent = (sessionReplayId) => ({
    schema: SCHEMA,
    data: {
        session_replay_id: sessionReplayId,
    },
});
exports.default = mixpanelSessionReplayStartEvent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWl4cGFuZWxTZXNzaW9uUmVwbGF5U3RhcnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZGF0YVN0cnVjdHVyZXMvZXZlbnRzL21peHBhbmVsU2Vzc2lvblJlcGxheVN0YXJ0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsTUFBTSxNQUFNLEdBQUcscUVBQXFFLENBQUM7QUFFckYsTUFBTSwrQkFBK0IsR0FBRyxDQUFDLGVBQXVCLEVBQXNCLEVBQUUsQ0FBQyxDQUFDO0lBQ3RGLE1BQU0sRUFBRSxNQUFNO0lBQ2QsSUFBSSxFQUFFO1FBQ0YsaUJBQWlCLEVBQUUsZUFBZTtLQUNyQztDQUNKLENBQUMsQ0FBQztBQUVILGtCQUFlLCtCQUErQixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/dataStructures/events/mixpanelSessionReplayStart.ts